import ReferrerStatisticRow from './ReferrerStatisticRow';

export default ReferrerStatisticRow;
